export enum ProfileActionType {
  UPDATE_PROFILE = 'UPDATE_PROFILE',
}

export function updateProfileAction(payload: any) {
  return async (dispatch: any) => {
    dispatch({ type: ProfileActionType.UPDATE_PROFILE, payload });
  };
}
